import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'routes/landing/components/Button';
import { CONDITION_DESKTOP } from 'shared/common/constants';
import styled from 'styled-components';
import { MainLayout } from 'widgets/layouts';

export const StopInfoBis: FC = () => {
  const { t } = useTranslation('header.component');

  const router = useRouter();

  return (
    <MainLayout hasFooter head={{ title: 'Инфоцыгане' }} isLoginButtonVisible>
      <Head>
        <meta name="title" content="Инфоцыгане" />
        <meta name="description" content="Инфоцыгане" />
        <meta name="og:title" content="Инфоцыгане" />
        <meta name="og:site_name" content="www.consulty.online" />
        <meta name="og:url" content="https://www.consulty.online/academy/" />
        <meta name="og:description" content="Инфоцыгане" />
      </Head>

      <h1 className="hidden">{t('head.title')}</h1>
      <Content className="container">
        <StyledHeading>Инфоцыгане</StyledHeading>
        <p>
          К сожалению, в России появилось много людей, продающих курсы, информацию, книги и семинары, которые не имеют
          практической ценности. Подробно о них рассказали в видео на YouTube{' '}
          <a href="https://youtu.be/o13xmfYNKDY" target="_blank" rel="noreferrer">
            Ксения Собчак
          </a>{' '}
          и команда{' '}
          <a href="https://youtu.be/15vIK_mS8dg" target="_blank" rel="noreferrer">
            Нескучных финансов
          </a>
          .
        </p>
        <p>
          Мы считаем такой подход к работе недопустимым и открыто выступаем против инфоцыган! Человек который платит за
          знания эксперта, должен получить от них реальную пользу.
        </p>
        <p>
          Consulty обожает людей, классно разбирающихся в чем-то, профессионалов и фанатов своего дела. Каждый день мы
          будем бороться за то, чтобы люди могли найти при помощи Consulty действительно толкового эксперта. Того, кто
          поможет решить практическую задачу и справиться с проблемой.{' '}
        </p>
        <p>Сейчас Consulty использует три инструмента, чтобы достичь этих целей:</p>
        <List>
          <ListItem>
            <ListIcon>
              <img
                src="https://storage.yandexcloud.net/consulty-stage/consulty-stage/public/hobby-i-rukodelie.svg"
                alt=""
              />
            </ListIcon>
            <ListContent>
              <ListTitle>Обязательная оценка консультации пользователем.</ListTitle>
              <ListText>
                Это занимает секунду, и без этого нельзя продолжать использовать сервис. Это сделано, чтобы выбирая
                эксперта, вы видели только реальные оценки и отзывы всех, кто ранее заказывал у него консультацию.
              </ListText>
            </ListContent>
          </ListItem>

          <ListItem>
            <ListIcon>
              <img src="https://storage.yandexcloud.net/consulty-stage/consulty-stage/public/blogging.svg" alt="" />
            </ListIcon>
            <ListContent>
              <ListTitle>Работа с жалобами и низкими оценками.</ListTitle>
              <ListText>
                Мы подробно проверяем консультации, по которым есть жалобы, низкие оценки и подозрительные действия — по
                12 параметрам. За критические нарушения аккаунты экспертов блокируются.
              </ListText>
            </ListContent>
          </ListItem>

          <ListItem>
            <ListIcon>
              <img
                src="https://storage.yandexcloud.net/consulty-stage/consulty-stage/public/buhgalteria-i-nalogi.svg"
                alt=""
              />
            </ListIcon>
            <ListContent>
              <ListTitle>Возврат стоимости консультации.</ListTitle>
              <ListText>
                Даже если у недобросовестного эксперта получится пробраться через нашу бдительную модерацию, не
                переживайте — мы возвращаем деньги в течение пары рабочих часов, если консультация вам не понравилась.
                Без разбирательств.
              </ListText>
            </ListContent>
          </ListItem>
        </List>
        <p>Нам важно, чтобы сами пользователи и эксперты помогли нам дать отпор информационным продуктам-пустышкам.</p>
        <p>
          Мы со своей стороны обещаем, что продолжим развивать и улучшать систему оценок, рейтингов и разрешения споров,
          чтобы сделать использование Consulty удобным, приятным и взаимовыгодным для пользователей и профессиональных
          экспертов.
        </p>
        <p>Удачных вам консультаций!</p>
        <p>
          <strong>P.S. cтикерпак «Без инфоцыган»</strong>
          <br />
          Кстати, мы сделали{' '}
          <a href="https://t.me/addstickers/not_infogypsies" target="_blank" rel="noreferrer">
            стикерпак «Без инфоцыган» для Telegram
          </a>
          . Можете использовать его в своем канале или просто в переписке для развлечения 😎
        </p>

        <StickerPack>
          <img src="/img/content-1-gupsy@2x.png" alt="" />
          <StickerPackTitle>Стикерпак «Без инфоцыган»</StickerPackTitle>
          <StickerPackText>Бесплатно</StickerPackText>
          <StyledButton $block isShadow>
            <a href="https://t.me/addstickers/not_infogypsies" target="_blank" rel="noreferrer">
              Добавить 11 стикеров
            </a>
          </StyledButton>
        </StickerPack>
      </Content>
    </MainLayout>
  );
};

const Content = styled.main`
  margin-bottom: 120px;
  ol {
    line-height: 1.4;
    > li {
      margin-bottom: 10px;
      white-space: break-spaces;
    }
  }
  a {
    color: #8b33ff;
  }
  p {
    max-width: 810px;
    font-size: 19px;
    line-height: 1.58;
    margin-bottom: 30px;
  }
`;

const StyledHeading = styled.h2`
  font-size: 24px;
  color: var(--black2);
  padding: 30px 0 30px;
  ${CONDITION_DESKTOP} {
    padding-top: 60px;
    padding-bottom: 30px;
    text-align: left;
    font-size: 42px;
  }
`;

const List = styled.div`
  margin: 40px 0 60px 0;
  display: flex;
  flex-direction: column;
  max-width: 810px;
`;

const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  &:not(:last-child) {
    margin-bottom: 40px;
  }
`;

const ListIcon = styled.div`
  margin-right: 40px;
`;

const ListContent = styled.div``;

const ListTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.58;
  margin-bottom: 10px;
`;

const ListText = styled.div`
  font-size: 19px;
  line-height: 1.58;
`;

const StickerPack = styled.div`
  img {
    max-width: 415px;
  }
  margin-bottom: 60px;
`;

const StickerPackTitle = styled.div`
  font-size: 19px;
  font-weight: 500;
  line-height: 1.58;
  margin-top: 20px;
`;

const StickerPackText = styled.div`
  font-size: 15px;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: normal;
  color: #79818c;
  margin-bottom: 20px;
`;

const StyledButton = styled(Button)`
  max-width: max-content;
  padding-left: 25px;
  padding-right: 25px;

  a {
    color: var(--white);
  }
`;
